import * as Sentry from '@sentry/react';
import { useAtom } from 'jotai';
import { useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';
import { userAtom } from './global-store';
import { Button, Typography } from '@eye-able/ui';

export default function ErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();
  const [user] = useAtom(userAtom);

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  let msg = error?.statusText || error?.message || error || 'Unknown error';

  if (typeof msg === 'object') {
    // error is an object but has no statusText or message
    try {
      const errorString = JSON.stringify(error);
      msg = errorString;
    } catch (e) {
      console.error('Failed to stringify error:', e);
      msg = String(error);
    }
  }

  const sendAdditionalInformation = () => {
    if (!document.getElementById('additionalInfo').value) {
      alert(t('additionalInformationMissing'));
      return;
    }
    // Send additional information to Sentry
    const userFeedback = {
      name: user?.fullName || 'No name',
      email: user?.email || 'No email',
      message: document.getElementById('additionalInfo').value,
      associatedEventId: Sentry.lastEventId() || 'User feedback',
    };

    Sentry.captureFeedback(userFeedback);
  };

  if (msg?.includes?.('Failed to fetch dynamically imported module')) {
    return (
      <Typography
        variant='headline-l'
        style={{
          padding: '3rem',
        }}
      >
        {t('versionOutdated')}
      </Typography>
    );
  }

  return (
    <Fragment>
      <Typography
        variant='headline-l'
        style={{
          padding: '3rem',
        }}
      >
        {t('unexpectedError')}:
      </Typography>

      <p
        style={{
          fontSize: '1.5rem',
          padding: '3rem',
          paddingTop: 0,
        }}
      >
        <i>{msg}</i>
      </p>

      <div
        style={{
          padding: '3rem',
          paddingTop: '1.5rem',
          fontSize: '1.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        <p>{t('provideAdditionalErrorInformation')}</p>
        <textarea
          className='eye:border eye:border-grey-100 eye:rounded-md eye:p-2xs eye:w-full'
          name='additionalInfo'
          id='additionalInfo'
          rows='5'
          aria-label={t('additionalInformation')}
          placeholder={t('additionalInformation')}
        ></textarea>
        <Button
          onClick={sendAdditionalInformation}
          style={{
            padding: '10px 14px',
            flexGrow: 0,
            alignSelf: 'flex-end',
          }}
        >
          {t('send')}
        </Button>
      </div>
    </Fragment>
  );
}
